module.exports = __webpack_public_path__ + "img/zhongguoyinhang.c045c282.png";